import React, {useEffect, useState} from 'react';
import {Button, Card, Form, Input, message, Select} from "antd";
import {SaveOutlined} from "@ant-design/icons";
import {useSelector} from "react-redux";
import {useGetMeQuery} from "../../../slices/rootApiSlices/authApiSlice";
import Error from "../../../components/Error";
import {useProfileUpdateMutation} from "../../../slices/rootApiSlices/settingsApiSlice";

const AccountActions = () => {

    const {user} = useSelector(state => state.auth)
    const [form] = Form.useForm();
    const {refetch, data, isLoading, error} = useGetMeQuery(user?.token);
    const [userUpdate, {error: isError, isLoading: loading}] = useProfileUpdateMutation()
    const [name, setName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isActive, setIsActive] = useState(false);
    const [language, setLanguage] = useState("");

    useEffect(() => {
        form.setFieldsValue(
            {
                name: data?.user?.name,
                phoneNumber: data?.user?.phoneNumber,
                isActive: data?.user?.isActive,
                language: data?.user?.language
            }
        );
    }, [data, form])

    const onFinish = async () => {
        const userData = {
            name: form.getFieldValue("name"),
            phoneNumber: form.getFieldValue("phoneNumber"),
            isActive: form.getFieldValue("isActive"),
            language: form.getFieldValue("language")
        }
        try {
            const res = await userUpdate({token: user?.token, data: userData, id: data?.user?.id}).unwrap();
            if (res) {
                refetch();
                message.success('Güncelleme işlemi başarılı', 3)
            }
        } catch (e) {
            message.error('Güncelleme sırasında hata oluştu.Lütfen bir süre sonra tekrar deneyiniz', 3)
        }
    }

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const {Option} = Select;

    if (error) {
        return <Error status="404" title={error[0]} subtitle="Lütfen daha sonra tekrar deneyiniz."/>
    }

    if (isError) {
        return <Error status="404" subtitle="Lütfen daha sonra tekrar deneyiniz."/>
    }

    if (isLoading) {
        return (
            <div>loading...</div>
        )
    }

    return (
        <>
                <Card title="Kullanıcı İşlemleri" size="small" type="inner" bodyStyle={{padding: 12, height: 190}}
              style={{boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: 10}}>
            <Form
                name="update-account-profiles"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                form={form}
                initialValues={{name: user?.name}}
            >
                <Form.Item label="İsim / Telefon No" style={{marginBottom: 0}}>
                    <Form.Item
                        style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: 'lütfen isim giriniz !',
                            },
                        ]}
                        onChange={e => setName(e.target.value)}
                        value={name}
                    >
                        <Input
                            disabled={loading}
                            placeholder="İsim"/>
                    </Form.Item>
                    <Form.Item
                        style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                        name="phoneNumber"
                        rules={[
                            {
                                required: true,
                                message: 'lütfen telefon numarası giriniz !',
                            },
                        ]}
                        onChange={e => setPhoneNumber(e.target.value)}
                        value={phoneNumber}
                    >
                        <Input
                            disabled={loading}
                            placeholder="Telefon numarası"/>
                    </Form.Item>
                </Form.Item>
                <Form.Item label="Dil / Durumu" style={{marginBottom: 0}}>
                    <Form.Item
                        style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                        name="language"
                        value={language}
                    >
                        <Select onChange={e => setLanguage(e)}
                                disabled={loading}
                                style={{margin: "auto", marginRight: 3, width: "100%"}}
                        >
                            <Select.Option value="tr">Türkçe</Select.Option>
                            <Select.Option value="en">İngilizce</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                        name="isActive"
                        value={isActive}
                    >
                        <Select
                            onChange={(e) => setIsActive({...isActive})}
                            allowClear
                            disabled={loading}
                        >
                            <Option value={true}>Aktif</Option>
                            <Option value={false}>Pasif</Option>
                        </Select>
                    </Form.Item>
                </Form.Item>
                <Form.Item style={{display: 'flex', justifyContent: 'flex-end'}}>
                    <Button style={{marginBottom: 5}}
                            disabled={loading}
                            loading={loading}
                            type="primary"
                            htmlType="submit"
                            icon={<SaveOutlined/>}
                    >
                        {loading ? 'Güncelleniyor' : 'Güncelle'}
                    </Button>
                </Form.Item>
            </Form>
        
        </Card>
        <Card
  title="Kullanıcı Ekleme"
  size="small"
  type="inner"
  bodyStyle={{ padding: 12, height: 200 }}
  style={{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: 10 }}
>
  <Form
    name="user-register"
    onFinish={async (values) => {
      try {
        const response = await fetch("https://api.myoctoopidev.com/v3/auth/register", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: values.email,
            password: values.password,
          }),
        });

        if (response.ok) {
          message.success("Kullanıcı başarıyla eklendi!", 3);
        } else {
          const err = await response.json();
          message.error(`Hata: ${err?.message || "Kullanıcı eklenemedi."}`, 3);
        }
      } catch (error) {
        message.error("Sunucuya bağlanırken hata oluştu.", 3);
      }
    }}
    autoComplete="off"
  >
    <Form.Item
      name="email"
      label="E-posta"
      rules={[
        {
          required: true,
          message: "Lütfen e-posta adresi giriniz!",
        },
        {
          type: "email",
          message: "Geçerli bir e-posta adresi giriniz!",
        },
      ]}
    >
      <Input placeholder="örnek@mertech.com.tr" />
    </Form.Item>

    <Form.Item
      name="password"
      label="Şifre"
      rules={[
        {
          required: true,
          message: "Lütfen şifre giriniz!",
        },
      ]}
    >
      <Input.Password placeholder="Şifre" />
    </Form.Item>

    <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
      <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
        Kullanıcı Ekle
      </Button>
    </Form.Item>
  </Form>
</Card>

        </>


    );
};

export default AccountActions;
